<script setup lang="ts">
import {SectionHero, SectionHeroContent} from '@/lib/ui/section-content';
import {useCdnUrl} from '@/composables/cdn-url';
const {translate} = useTranslation();
</script>

<template>
  <SectionHero class="crystal-vip-hero-section w-full" :src-url="`${useCdnUrl()}/assets/crystal-vip/nye-ball-bg-video`" :poster="`${useCdnUrl()}/assets/crystal-vip/nye-vip-bg-poster.webp`">
    <SectionHeroContent class="crystal-vip-hero-section__content">
      <div class="hero-content">
        <img :src="`${useCdnUrl()}/assets/crystal-vip/nye-vip-logo.svg`" alt="NYE Ball Crystal VIP Experience Logo" />

        <ul class="crystal-vip-hero-section__content-cta">
          <li>
            <TheButton tag="NuxtLink" class="!border-none !bg-[var(--crystal-vip-color-darker)] !py-4 w-[270px] hover:!bg-black hover:!text-white" to="/nye-ball-crystal-vip-experience#buy-tickets" aria-label="Buy tickets for Times Travel VIP">See Our Offers</TheButton>
          </li>
          <li>
            <TheButton tag="NuxtLink" class="!border-none !bg-[var(--crystal-vip-color-darker)] !py-4 w-[270px] hover:!bg-black hover:!text-white" to="/nye-ball-crystal-vip-experience" aria-label="Learn more Times Travel VIP">Learn More</TheButton>
          </li>
        </ul>
      </div>
    </SectionHeroContent>
  </SectionHero>
</template>
<style lang="scss" scoped>
@use '@/assets/scss/queries';
.crystal-vip-hero-section {
  background-image: url('/assets/crystal-vip/tt-vip-hero.webp');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  max-height: 1146px;

  .crystal-vip-hero-section__content {
    justify-content: end;

    .hero-content {
      display: flex;
      flex-direction: column;
      gap: 2rem;
      justify-content: end;

      margin-right: 15rem;
      max-width: 700px;
      width: 100%;

      @include queries.for-size(phone) {
        margin-right: 0;
        align-items: end;
        margin-top: auto;
        padding-bottom: 6rem;
      }

      img {
        height: auto;
        margin-bottom: 1rem;
        width: 100%;
      }

      .crystal-vip-hero-section__content-cta {
        align-items: center;
        display: flex;
        flex-direction: row;
        gap: 5rem;
        justify-content: flex-start;
        width: 100%;

        @include queries.for-size(phone) {
          gap: 2rem;
          flex-direction: column;
          gap: 2rem;
          li {
            width: 100%;
            a {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
